import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import NearbyVmList from "./NearbyVmList";
import RecentVmList from "./RecentVmList";
import NoVmFound from "./NoVmFound";
import { Box } from "@mui/material";
import Banner_Container from "../../Banners/container";
import SearchBar from "./SearchVm";
import LocationPage from "./LocationPage";
import Game from "../Game/component";
import TopNavbar from "./header";
import QrModal from "./Qr";
import BottomNarBar from "../../BottomNav/Bottom";
import Procced from "../../ProccedToPay/component";
import PendingPickup from "../PendingPickup/component";
import CategoryItem from "./Category/component";
import NoActiveMachine from "../VmInventory/NoActiveMachine";
import ReplaceCartModal from "../../PopUp/ReplaceCartPopUp";
import { set } from "date-fns";
import WaitingLoder from "../../Loader/component";
import CategoriesModal from "./Category/CategoryPopUp";
import { API_BASE_URL } from "../../config";
import LoyaltyCongratsDialog from "./LoyaltyCongratsDialog";
const VmlistContainer = () => {
  const { makeApiRequest } = useApiRequest();
  const navigate = useNavigate();

  const [nearbyVmlist, setNearbyVmlist] = useState([]);
  const [recentVmlist, setRecentVmlist] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [activeOrders,setActiveOrders]=useState([])
 const [machine_uuid_flag,setMachine_uuid_flag]=useState(false)
 const [uuid_vmId,setUuid_vmId]=useState(null)
 const [categories,setCategories]=useState([])
 const [loader,setLoader]=useState(false)
 const [categoriesWiseVmItems,setCategoriesWiseVmItems]=useState([])
  const [replaceSlot, setReplaceSlot] = useState(null);
   const [replaceCard, setReplaceCard] = useState(false);
   const [preCardMachineId,setPreCardMachineId]=useState(null)
   const [viewall,setViewall]=useState(false)
   const [milestoneData, setMilestoneData] = useState({
  currentLevelMilestoneCount: 0,
  reward: null,
  level:1
});
const [openCongrats, setOpenCongrats] = useState(false);
  const gotohome=()=>{
   setMachine_uuid_flag(false)
  }
  const [loading, setLoading] = useState(false);
  const [qrModelflag, setQrModelflag] = useState(false);
    const [preCart, setPreCart] = useState([]);
    const [showLoction,setshowLoction]=useState(true)
const [categoriesid,setCategoriesid]=useState(null)
 const [userDetails, setUserDetails] = useState(null);
  // Redirect if user is not logged in
  useEffect(() => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    if (!UserJWTAuth) navigate("/login");
  }, [navigate]);

  // Fetch VM list if location exists
  useEffect(() => {
    const lat = localStorage.getItem("lat");
    const lng = localStorage.getItem("lng");
    if (lat && lng && navigator.onLine) {
      fetchVmList(lat, lng);
    }
  }, []);

  const getLocation = () => {
    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by this browser.", { autoClose: 2000 });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        const { latitude, longitude } = coords;
        localStorage.setItem("lat", latitude);
        localStorage.setItem("lng", longitude);
        fetchVmList(latitude, longitude);
      },
      (error) => {
        const messages = {
          1: "User denied the request for Geolocation",
          2: "Location information is unavailable",
          3: "The request to get user location timed out",
        };
        toast.error(messages[error.code] || "An unknown error occurred", { autoClose: 2000 });
      }
    );
  };

  const fetchVmList = (lat, lng) => {
    setshowLoction(false)
    setLoading(true);
    const token = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");

    makeApiRequest({
      //url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/outlet/search?nearbyLimit=50&recentLimit=6&lat=${lat}&lng=${lng}`,
      url: `${API_BASE_URL}/consumerbe/api/v2/outlet/search?nearbyLimit=50&recentLimit=6&lat=${lat}&lng=${lng}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId,
      },
      handleSuccess: (res) => {
        
        setNearbyVmlist(res?.data.data.nearbyMachines || []);
        setRecentVmlist(res?.data.data.recentMachines || []);
        setLoading(false);
      },
      handleError: (err) => {
        //console.error("VM List Error:", err);
        toast.error("Failed to load vending machines.", { autoClose: 1500 });
        setLoading(false);
      },
    });
  };

  const fetchUserDetails = () => {
    const token = localStorage.getItem("UserJWTAuth");
    if (!token) return;

    const deviceId = localStorage.getItem("uuid");
    makeApiRequest({
      //url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/user/loyalty/details`,
      url: `${API_BASE_URL}/consumerbe/api/v2/user/loyalty/details`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
handleSuccess: (res) => {
  const userData = res?.data?.data;

  setUserDetails(userData);

   const reward =
    userData?.levelRewards?.find(
      (item) =>
        item.milestoneCount === userData.currentLevelMilestoneCount
    ) || false;

  setMilestoneData({
    currentLevelMilestoneCount: userData.currentLevelMilestoneCount,
    reward: reward,
    levelId:userData.levelId
  });

  const  levelId=userData.levelId, currentLevelMilestoneCount=userData.currentLevelMilestoneCount

  // unique key for this state
  const uniqueKey = `levelId_${levelId}_milestone_${currentLevelMilestoneCount}`;

  const alreadyShown = localStorage.getItem("lastShownMilestone");

  if (alreadyShown !== uniqueKey) {
    // show popup
    setOpenCongrats(true);

    // save it
    
  }

  console.log("milestoneData", {
    currentLevelMilestoneCount: userData.currentLevelMilestoneCount,
    reward:reward,
    levelId:userData.levelId
  });
},
      handleError: () => {},
    });
  };


    const fetchPreCart = () => {
      const token = localStorage.getItem("UserJWTAuth");
      if (!token) return;
  
      makeApiRequest({
        //url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/cart`,
        url: `${API_BASE_URL}/consumerbe/api/v2/cart`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
        handleSuccess: handleResponsePreCart,
        handleError: handleErrorPreCart,
      });
    };
  
  
    const fetchActiveOrders = () => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");
  
    makeApiRequest({
      //url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/order/active`,
      url: `${API_BASE_URL}/consumerbe/api/v2/order/active`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId,
        accept: "application/json, text/plain, */*",
      },
      handleSuccess: (res) => {
        //console.log("Active Orders Response:", res?.data?.data);
        // Do something with active orders, e.g.,
        setActiveOrders(res?.data?.data || []);
      },
      handleError: (err) => {
       // console.error("Failed to fetch active orders:", err);
      /*   toast.error("Unable to fetch active orders.", {
          position: "top-right",
          autoClose: 1500,
        }); */
      },
    });
  };
  
    const handleResponsePreCart = (res) => {
      const cartItems = res?.data?.data?.items || [];
      const preMachineId = res?.headers?.["machineid"];
   const totalAmount = cartItems.reduce((sum, item) => sum + (item.amount * item.count), 0);
   console.log("incoming  preMachineId",preMachineId)
  setPreCardMachineId(preMachineId);
  localStorage.setItem("machineId", preMachineId);
  //console.log("Total Amount:", totalAmount);
   if(categoriesid){
        fetchCategoriesWise(categoriesid,cartItems,preMachineId)
      }
        setTotalAmount(totalAmount);
  
      setPreCart(cartItems);
     
     

    };
  
    const handleErrorPreCart = (error) => {
      //console.error("❌ Pre-cart fetch error:", error);
      if (error.response?.status === 401 || error.response?.status === 403) {
        localStorage.removeItem("UserJWTAuth");
      
      } else {
        toast.error(`${error.response?.data?.status?.code || "Error"}`, {
          position: "top-right",
          autoClose: 1000,
        });
      }
    };

  useEffect(() => {
    fetchUserDetails();
    fetchPreCart()
    fetchActiveOrders()
    fetchCategories()

  }, []);





    const handleResponseAddIntoCart = (res, slot_id, operation) => {
     
      setLoader(false)
      localStorage.setItem("card_id", res.headers["cart-id"]);
        console.log("mapped data-----",res?.data?.data,categoriesWiseVmItems.items)
       
        setPreCart(res?.data?.data?.items || []);
       
       fetchPreCart()

        if(categoriesid){
        //fetchCategoriesWise(categoriesid,preCart)
         
       
      }
  
      const cartItems = res?.data?.data?.items || [];
      
  
     
  
 
    };
  
  
    const handleErrorAddIntoCart = (err) => {
       setLoader(false)
      if (
        err.response &&
        err.response.data.status.message ===
          "Cart contains items from another machine"
      ) {
        setReplaceCard(true);
      }
      toast.error(`${err.response?.data?.status?.message}`, {
        position: "top-right",
        autoClose: 1500,
      });
    };
  
    const handleCartOpertation = (e, index, slot_id, currentCount, operation,machineId) => {
    setLoader(true)
      console.log("currentCount",currentCount,operation,machineId)
      // setLoader(true)
      e.stopPropagation();
      const token = localStorage.getItem("UserJWTAuth");
   
  
      const payloadCount = operation === "add" ? currentCount + 1 : currentCount - 1;
  
      if ((preCart?.length > 0) ) {
        setReplaceSlot({ slot_id, index,machineId });
      } 
  
      makeApiRequest({
        //url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/cart?machineId=${machineId}&replace-cart=${replaceCard}`,
        url: `${API_BASE_URL}/consumerbe/api/v2/cart?machineId=${machineId}&replace-cart=${replaceCard}`,
        method: "PATCH",
        headers: { Authorization: `Bearer ${token}` },
        data: [{ slotId: parseInt(slot_id), count: payloadCount }],
        handleSuccess: (res) => handleResponseAddIntoCart(res, slot_id, operation),
        handleError: handleErrorAddIntoCart,
      });
    };
  

  const fetchCategoriesWise = (id,cartItems,preMachineId) => {
    setCategoriesid(id)
    //setLoader(true)
    const token = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");

    makeApiRequest({
      //url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/outlet-wise/inventory?page=0&size=100&lat=${localStorage.getItem("lat")}&lng=${localStorage.getItem("lng")}&categoryId=${id}`,
      url: `${API_BASE_URL}/consumerbe/api/v2/outlet-wise/inventory?page=0&size=100&lat=${localStorage.getItem("lat")}&lng=${localStorage.getItem("lng")}&categoryId=${id}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId,
      },
      handleSuccess: (res) => {
        //console.log("category wise items",res)  
       // setCategoriesWiseVmItems(res?.data?.data || []);
       

       const loadData = async () => {
  const data = await mapSlotsWithMyCount(
    res?.data?.data,
    cartItems ? cartItems : preCart,
    preMachineId
  );

  console.log("mapped data", data);
  setCategoriesWiseVmItems(data);
};

// call it
loadData();

         //console.log("mapped data",data)
         //setCategoriesWiseVmItems(data);
        setLoader(false)
        ///fetchPreCart()
      },
      handleError: (err) => {
        setLoader(false)
        //console.error(err)


      },

    });
  };

  const fetchCategories = () => {
    //setLoader(true)
    const token = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");

    makeApiRequest({
      //url: "https://api-prod.daalchini.co.in/consumerbe/api/v2/item/category",
      url: `${API_BASE_URL}/consumerbe/api/v2/item/category`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId,
      },
      handleSuccess: (res) => {
        setCategories(res?.data?.data || []);
        setLoader(false)
       
      },
      handleError: (err) => {
        setLoader(false)
        //console.error(err)


      },

    });
  };
const fetchMachineByUUID = (uuid) => {
  const UserJWTAuth = localStorage.getItem("UserJWTAuth");
setUuid_vmId(uuid)
  makeApiRequest({
    //url: https://api-prod.daalchini.co.in/consumerbe/api/v2/outlet/machinebyuuid/${uuid}`,
      url: `${API_BASE_URL}/consumerbe/api/v2/outlet/machinebyuuid/${uuid}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${UserJWTAuth}`,
    },
    handleSuccess: (res) => {
      const machineId = res?.data?.data?.machineId;
      if (machineId) {
        //fetchVmInventory(machineId);
        
        navigate(`/items?machineId=${machineId}&value=${uuid}`)
      } else {

        toast.error("Machine not found for this device", {
          position: "top-right",
          autoClose: 1500,
        });
      }
    },
    handleError: (err) => {
     
      const code = err.response.data.status.code
             
  console.log("uuid",uuid)
  setMachine_uuid_flag(true)
  

if(code=="UNAUTHORIZED"){
      navigate(`/login?value=${uuid}`)
}

 /*      toast.error("Failed to fetch machine by UUID", {
        position: "top-right",
        autoClose: 1500,
      }); */
    },
  });
};


  const ShowQRFun = (e) =>{
    
    setQrModelflag(true)



  }

    const CloseQrFun = (e) =>{
    
    setQrModelflag(false)



  }

  const lat = localStorage.getItem("lat");
  const lng = localStorage.getItem("lng");

  if (showLoction) return <LocationPage fetchVmList={fetchVmList}   setshowLoction={ setshowLoction}  />;
if(machine_uuid_flag){
 return <NoActiveMachine uuid={uuid_vmId}  gotohome={gotohome}/>
}

  const replaceMyCardFun = (e) => {
    setReplaceCard(false);
    if (replaceSlot)
      handleCartOpertation(e, replaceSlot.index, replaceSlot.slot_id, 0, "add",replaceSlot.machineId);
  };


async  function mapSlotsWithMyCount(vmList, cartItems, preCardMachineId) {
  console.log("🧾 Incoming vmList:", vmList);
  console.log("🛒 Incoming cartItems:", cartItems);
  console.log("🎯 Incoming preCardMachineId:", preCardMachineId);

  return vmList.map(vm => {
    console.log(`\n🏭 Processing VM ${vm.vmId}`);

    const vmCartItems = cartItems.filter(item => {
      const isMatch =
        preCardMachineId == vm.vmId;

      console.log(
        `🧪 Checking cart item → item.vmId: ${item.vmId}, preCardMachineId: ${preCardMachineId}, vm.vmId: ${vm.vmId} → ${
          isMatch ? "✅ MATCH" : "❌ NO MATCH"
        }`
      );

      return isMatch;
    });

    console.log(
      `➡️ Cart items for VM ${vm.vmId}:`,
      vmCartItems.length ? vmCartItems : "❌ None"
    );

    return {
      ...vm,
      slotDetails: vm.slotDetails.map(slot => {
        console.log(`   🔹 Checking Slot ${slot.slotId}`);

        const matchedItem = vmCartItems.find(
          item => item.slotId === slot.slotId
        );

        if (matchedItem) {
          console.log(
            `   ✅ MATCH FOUND → slotId ${slot.slotId}, myCount = ${matchedItem.count}`
          );
        } else {
          console.log(
            `   ⚠️ No cart item for slotId ${slot.slotId}, myCount = 0`
          );
        }

        return {
          ...slot,
          myCount: matchedItem ? matchedItem.count : 0
        };
      })
    };
  });
}

  const handleCloseCongrats = () => {
  const key = `levelId_${milestoneData.levelId}_milestone_${milestoneData.currentLevelMilestoneCount}`;

  // save here 👇
  localStorage.setItem("lastShownMilestone", key);

  setOpenCongrats(false);
}

  return (
    <>
   <LoyaltyCongratsDialog
  open={openCongrats}
  onClose={handleCloseCongrats}
  medalImage={milestoneData?.levelImage}
  milestoneData={milestoneData}
/>
    {loader && <WaitingLoder/>}
      {qrModelflag ? (
        <QrModal ShowQRFun={ShowQRFun} qrModelflag={qrModelflag}  CloseQrFun={CloseQrFun}  fetchMachineByUUID={fetchMachineByUUID} />
      ) : (
        <>
              {replaceCard && (
        <ReplaceCartModal
          replaceMyCardFun={replaceMyCardFun}
          setReplaceCard={setReplaceCard}
        />
      )}

          <TopNavbar
            LoctionPinHeader={true}
            QrMarkHeader={true}
            shareLocation={getLocation}
            ShowQRFun={ShowQRFun}
           preCart={preCart}
          />
          <Box
            sx={{
              padding: 2,
              position: "relative",
              minHeight: "100vh",
              background: "radial-gradient(circle, rgba(245,233,233,0.4) 0%, rgba(185,245,247,0.34) 100%)",
              overflow: "hidden",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0,0,0,0.1)",
                zIndex: 0,
                animation: "fadeOverlay 5s ease-in-out infinite alternate",
              },
              "@keyframes fadeOverlay": {
                from: { opacity: 0.2 },
                to: { opacity: 0.4 },
              },
            }}
          >
            <Box sx={{ position: "relative", zIndex: 1 }}>
             
             {userDetails&& <Game data={userDetails} />}
              <Banner_Container vmid={0} />
              <SearchBar />               <CategoryItem categories={categories} fetchCategoriesWise={fetchCategoriesWise} categoriesWiseVmItems={categoriesWiseVmItems} setCategoriesWiseVmItems={setCategoriesWiseVmItems} handleCartOpertation={handleCartOpertation}  setViewall={setViewall} viewall={viewall}/>             
              <div
  style={{
    paddingBottom:
      activeOrders && activeOrders[0] && preCart && preCart[0]
        ? "135px"
        : preCart && preCart[0]
        ? "50px"
        : activeOrders && activeOrders[0] && activeOrders.length > 1
        ? "115px"
        : activeOrders && activeOrders[0]
        ? "80px"
        : "0px", // fallback padding if none are true
  }}
>
                {recentVmlist.length > 0 && (
                <RecentVmList recentVmlist={recentVmlist} loading={loading} onFetchLocation={getLocation} />
              )}

              {nearbyVmlist.length > 0 && (
                <NearbyVmList nearbyVmlist={nearbyVmlist} loading={loading} onFetchLocation={getLocation} />
              )}
              </div>
            
              {nearbyVmlist.length === 0 && recentVmlist.length === 0 && <NoVmFound />}
            </Box>
          </Box>
                {preCart&&preCart[0]&&<Procced preCart={preCart}  totalAmount={totalAmount}  bottom={"90px"} page={"vmlist"}/>}
                 {activeOrders&&activeOrders[0]&&<PendingPickup activeOrders={activeOrders} preCart={preCart}  page={"vmlist"}/>}

          <BottomNarBar/>
        </>
      )}
    </>
  );
};

export default VmlistContainer;
